import styled from 'styled-components';
import { Stack } from '@mui/material';
import { ReactComponent as InfoIcon } from '../../assets/info.svg';
import OverflowTooltip from '../OverflowTooltip';

const Wrapper = styled(Stack)<{ $fullWidth?: boolean }>`
  align-items: center;
  padding: 0 6px;
  background-color: ${({ theme }) => theme.palette.common.gray5};
  border-radius: 2px;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '250px')};
  gap: '4px';

  & svg {
    color: ${({ theme }) => theme.palette.common.blue};
    margin-left: 3px;
  }
`;

const OverflowInfo = ({
  value,
  fullWidth,
}: {
  value: string;
  fullWidth?: boolean;
}) => (
  <Wrapper direction="row" sx={{ alignItems: 'center' }} $fullWidth={fullWidth}>
    <OverflowTooltip icon={InfoIcon}>{value}</OverflowTooltip>
  </Wrapper>
);

export default OverflowInfo;
